<template>
  <div class="d-flex justify-content-center align-items-center full-height">
    <div class="p-4 rounded shadow-lg">
      <img src="@assets/images/logo-processus.svg" class="mb-3 logo" />
      <h4 class="mb-5">Bienvenido al portal<br />Colaboradores de Processus</h4>
      <DxButton @click="doEnter" type="success" class="d-flex">{{ $t("shared.ui.buttons.access") }}</DxButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "@/.shared/services/routing-services";
import { useAuthentication } from "@services/auth/authentication";
import DxButton from "devextreme-vue/button";
import { onMounted } from "vue";

const props = defineProps<{
  redirectTo?: string;
  preferredIdp?: string | null;
}>();
const router = useRouter();
const auth = useAuthentication();

// Función para iniciar login con IdP preferido
function doEnter() {
  if (auth.isLoggedIn()) {
    if (props.redirectTo) router.replace(props.redirectTo);
    else router.replace({ name: "operaciones" });
  } else {
    auth.login(`${import.meta.env.BASE_URL}${props.redirectTo ?? ""}`, props.preferredIdp || undefined);
  }
}

// Función para limpiar el parámetro preferredIdp de la URL
function cleanPreferredIdpFromUrl() {
  if (props.preferredIdp) {
    const url = new URL(window.location.href);
    url.searchParams.delete("preferredIdp");
    window.history.replaceState({}, "", url.toString());
  }
}

// Si hay un IdP preferido y el usuario no está logueado, iniciar login automáticamente
onMounted(() => {
  if (props.preferredIdp && !auth.isLoggedIn()) {
    cleanPreferredIdpFromUrl();
    doEnter();
  }
});
</script>
<style scoped lang="scss">
.full-height {
  height: 100%;
}
.logo {
  max-width: 200px;
}
</style>
